import { motion } from 'framer-motion';
import { Animations } from '../../const';

const PageContainer = (props) => {
  return (
    <motion.section 
      {...props}
      {...(props.animation ? Animations.fade : {})}>
      {props.children}
    </motion.section>
  )
}

export default PageContainer;